// Mapeia a decisão do servidor (5.3: o servidor decide a ação) para o feedback da tela da sala.
// Puro e sem React para ser testável em ambiente node.
import type { ScanAction, ScanResponse } from "@centro-cirurgico/contracts";

export type ScanTone = "ok" | "warn" | "error" | "info";

export interface ScanFeedback {
  tone: ScanTone;
  title: string;
  detail?: string | undefined;
  /** Aviso ao operador (âmbar), ex.: acompanhante não será notificado. */
  warning?: string | undefined;
}

/** Diálogo que a tela precisa abrir antes de concluir a ação. */
export type ScanDialog = "name_required" | "confirm_exit" | null;

export interface ScanOutcome {
  feedback: ScanFeedback | null;
  dialog: ScanDialog;
}

const COMPANION_NOTIFIED = "O acompanhante será avisado.";
const EXIT_TITLE = "Saída registrada. Sala em setup.";

/**
 * Descreve o resultado de uma leitura. Quando `dialog` não é nulo, `feedback` é nulo:
 * a tela mantém o leitor pausado e abre o diálogo antes de concluir.
 */
export function describeScanResult(action: ScanAction, response?: Pick<ScanResponse, "warning" | "companionWillBeNotified" | "stay">): ScanOutcome {
  switch (action) {
    case "entry":
      return {
        dialog: null,
        feedback: {
          tone: "ok",
          title: "Entrada registrada",
          detail: response?.companionWillBeNotified ? COMPANION_NOTIFIED : undefined,
          warning: response?.warning ?? undefined
        }
      };
    case "exit":
      return {
        dialog: null,
        feedback: {
          tone: "ok",
          title: EXIT_TITLE,
          detail: response?.companionWillBeNotified ? COMPANION_NOTIFIED : undefined,
          warning: response?.warning ?? undefined
        }
      };
    case "duplicate":
      return {
        dialog: null,
        feedback: { tone: "warn", title: "Leitura repetida ignorada", detail: "A pulseira já foi lida há pouco." }
      };
    case "name_required":
      return { dialog: "name_required", feedback: null };
    case "exit_confirmation_required":
      return { dialog: "confirm_exit", feedback: null };
  }
}

/** Feedback após a saída confirmada pelo operador (`POST /confirm-exit`). */
export function exitConfirmedFeedback(): ScanFeedback {
  return { tone: "ok", title: EXIT_TITLE };
}

/** Feedback para erros de negócio devolvidos pela API (409/422) ou falhas de rede. */
export function scanErrorFeedback(title: string): ScanFeedback {
  return { tone: "error", title };
}
